import React from 'react';

import { LinkButton, StandardButton } from '@eika/button';
import { WarningCard } from '@eika/card';

import type { RecurringPaymentType } from '../../generated-types';
import useTranslation, { format } from '../../hooks/useTranslation';
import { useSigningContext } from '../../signingContext/signingContext';
import { Actions } from '../../signingContext/signingTypes';
import { paymentTrackIDs } from '../../utils/gtm/trackIDs/payment';

import './TransactionModal.scss';
import './TransactionResultInfo.scss';

export interface Props {
    onClose: () => void;
    avtalegiro?: boolean;
    recurringPaymentType?: RecurringPaymentType;
}

const UpdateRetry: React.FC<Props> = ({ onClose, avtalegiro = false, recurringPaymentType }) => {
    const translated = useTranslation();

    const { dispatch } = useSigningContext();

    const notSignedMessage = avtalegiro
        ? translated.avtalegiroValidation.notSignedUpdate
        : translated.recurringPaymentValidation.notSigned;

    const cancelOperation = () => {
        dispatch({ type: Actions.RESET });
        onClose();
    };

    const onRetry = () => {
        dispatch({ type: Actions.RESET });
    };

    const onEdit = () => {
        dispatch({ type: Actions.CANCEL_SIGNING });
    };

    const trackID = avtalegiro ? paymentTrackIDs.avtalegiro.update : paymentTrackIDs.recurring.update;

    return (
        <div className="centered-modal-content">
            <WarningCard title={notSignedMessage.heading} isModal>
                <p>
                    {recurringPaymentType
                        ? format(notSignedMessage.description, translated.recurringPaymentType[recurringPaymentType])
                        : notSignedMessage.description}
                </p>
                <div className="transaction-result-info__warning-button-row">
                    <div className="transaction-result-info__first-row">
                        <StandardButton
                            className="transaction-result-info__change-btn"
                            buttonType="negative"
                            onClick={onEdit}
                            data-track-id={trackID}
                            data-track-linkname={notSignedMessage.change}
                        >
                            {notSignedMessage.change}
                        </StandardButton>
                        <StandardButton
                            className="transaction-result-info__retry-btn"
                            onClick={onRetry}
                            data-track-id={trackID}
                            data-track-linkname={notSignedMessage.tryAgain}
                        >
                            {notSignedMessage.tryAgain}
                        </StandardButton>
                    </div>
                    <LinkButton
                        onClick={cancelOperation}
                        data-track-id={trackID}
                        data-track-linkname={notSignedMessage.cancel}
                    >
                        {notSignedMessage.cancel}
                    </LinkButton>
                </div>
            </WarningCard>
        </div>
    );
};

export default UpdateRetry;
